/* eslint-disable import/no-cycle */
import React from 'react';
import { Router } from '@gatsbyjs/reach-router';
import { Dashboard, Retrieve, FutureCruiseCredit, PaymentContainer } from './pages';

const Routes = ({ urlPath = '' }) => (
  <Router>
    <Dashboard default path={`${urlPath}/dashboard`} />
    <Retrieve path={`${urlPath}/lookup/*`} />
    <FutureCruiseCredit path={`${urlPath}/future-cruise-credit`} />
    <PaymentContainer path={`${urlPath}/payment`} />
  </Router>
);

export default Routes;
